import type {Thread} from '@github-ui/diff-lines/conversation-types'
import {ProfileReference} from '@github-ui/profile-reference'
import {Link} from '@github-ui/react-router'
import {useGetHovercardAttributesForType} from '@github-ui/hovercards/use-get-hovercard-attributes-for-type'
import {ThreadGroupVariant, getThreadAuthorLogin, ThreadGroupVariantLabels} from '../util/classify-thread'

export function ThreadTitle({thread, variant}: {thread?: Thread | null; variant: ThreadGroupVariant}) {
  const getHovercardAttributesForType = useGetHovercardAttributesForType()

  const message = ThreadGroupVariantLabels[variant] || 'commented'

  // Falls back to the ghost user (login `ghost`, profile `/ghost`) when the
  // comment author no longer exists, matching the expanded thread view.
  const authorLogin = getThreadAuthorLogin(thread, variant)

  return (
    <span>
      <Link
        to={`/${authorLogin}`}
        className="color-fg-default text-bold"
        {...getHovercardAttributesForType('user', {login: authorLogin})}
      >
        <ProfileReference login={authorLogin} isAgent={false} />
      </Link>
      {` ${message}`}
    </span>
  )
}
